import React from "react";
import "../../../css/NuestraCiudad/plan-accion-clima.css";

const PlanAccionClima = () => (
  <div className="container plac-container">
    <h3>PLAC (Plan Local de Acción Climática)</h3>
    <p>
      El PLAC es una herramienta de planificación estratégica de un gobierno local que permite optimizar la gestión de recursos técnicos y económicos, internos y externos, para hacer posible la transición hacia una ciudad resiliente.
    </p>
    <p>
      Nuestra Ciudad, con el accionar de cada vecino y vecina, fue reconocida por el Pacto Global de Alcaldes por el Clima y la Energía, la mayor alianza global para el liderazgo climático de las ciudades, por su acción de “Compromiso” en la Mitigación y Adaptación al cambio climático, destacando que Oliva está adherida a la Red Argentina de Municipios frente al Cambio Climático (RAMCC).
    </p>
    <p>
      De esta manera, nuestra localidad ha recibido junto a otros 8 municipios de Argentina, que también conforman la Red, la mayor medalla que se otorga al cumplir con las 3 etapas (compromiso, mitigación y adaptación): el sello de “Conformidad”.

    </p>

    <div className="text-center my-4">
      <img src={require("../../img/plac.jpg")} alt="PLAC Oliva" className="plac-img" />
    </div>

    <p>
      En nuestra ciudad, el Plan Local de acción climática está aprobado por la ordenanza 257/2022, lo que asegura la continuidad en el tiempo, de manera interdisciplinaria, junto a los demás actores locales.
      Para conocer el PLAC completo ingresa al siguiente link{" "}
      <a
        href="https://ciudaddeoliva.gov.ar/sys/file/plac/plac.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        (Ver mas)
      </a>{" "}
      y podrás conocer todas las acciones de lucha contra el cambio climático.
    </p>
  </div>
);

export default PlanAccionClima;
